<template>
  <span v-if="!hideIfLevel0 || clientEscalationLevel.level !== 'level0'">
    <span
      class="badge client-escalation-level"
      :class="clientEscalationLevel.level"
    >
      {{ $t(`client.levels.${clientEscalationLevel.level}`) }}
      <template v-if="clientEscalationLevel.date && showEscalationDate">
        (since {{ formatRotaStartDateMedium(clientEscalationLevel.date) }})
      </template>
    </span>
  </span>
</template>

<script>
import { formatRotaStartDateMedium } from "../../lib/date-functions";
import { getClientEscalationLevelForDate } from "../../lib/client-functions";

export default {
  name: "ClientEscalationLevel",
  props: {
    client: {
      type: Object,
      required: true,
    },
    date: {
      type: Date,
      default() {
        return new Date();
      },
    },
    hideIfLevel0: {
      type: Boolean,
      default() {
        return false;
      },
    },
    showEscalationDate: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  setup() {
    return {
      formatRotaStartDateMedium,
      getClientEscalationLevelForDate,
    };
  },
  computed: {
    clientEscalationLevel() {
      return getClientEscalationLevelForDate(this.client, this.date);
    },
  },
};
</script>
